module.exports = __webpack_public_path__ + "static/verkehrsflaechen-a4f27bc97abc5a66a2ba4ce79af72404.PNG";